import { render, staticRenderFns } from "./TagsCategories.vue?vue&type=template&id=7d51bc88"
import script from "./TagsCategories.vue?vue&type=script&lang=js"
export * from "./TagsCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports